import * as React from "react";
import JsxParser from "@recursive-robot/react-jsx-parser";
import { useCanvasBindings } from "../../../shared/providers/CanvasBindingsProvider";
import { useJsxParserComponents } from "../../../shared/providers/JsxParserComponentsProvider";
import InlineContentErrorBoundary from "../../../shared/components/InlineContentErrorBoundary";
import { useTemplateDiagnostics } from "../../../shared/hooks/useTemplateDiagnostics";
import { Markdown } from "../../../shared/components/Markdown";

const blacklistedAttrs = [];
const blacklistedTags = [];
const renderError = ({ error }) => <Markdown content={error} />;

export interface JsxRendererProps {
    template: string;
    data?: any;
}

function _JsxRenderer(props: JsxRendererProps) {
    const { template, data, ...rest } = props;
    const _bindings = useCanvasBindings();
    const components = useJsxParserComponents();
    const onError = useTemplateDiagnostics(undefined, template);

    const bindings = { ..._bindings, ...data };

    return (
        <InlineContentErrorBoundary key={template}>
            <JsxParser
                bindings={bindings}
                components={components}
                jsx={template}
                blacklistedAttrs={blacklistedAttrs}
                blacklistedTags={blacklistedTags}
                onError={onError}
                renderError={renderError}
                renderInWrapper={false}
                key={template} // Force re-parse when template content is updated
                {...rest}
            />
        </InlineContentErrorBoundary>
    );
}

const JsxRenderer = React.memo(_JsxRenderer);

export { JsxRenderer }; 